import { render, staticRenderFns } from "./Highlights.vue?vue&type=template&id=00d80af8&scoped=true&"
import script from "./Highlights.js?vue&type=script&lang=js&"
export * from "./Highlights.js?vue&type=script&lang=js&"
import style0 from "./Highlights.vue?vue&type=style&index=0&id=00d80af8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00d80af8",
  null
  
)

export default component.exports